export const LOCAL_STORAGE = {
  DATA: 'mobadrafter_data',
};

export const LEVEL = {
  STRONG: '10',
  GOOD: '7',
  MIDDLE: '5',
  WEAK: '3',
  NONE: '0',
};
